import { MsalAuthProvider, LoginType } from "react-aad-msal";
// Config object to be passed to Msal on creation
let Preprod = false;
let redirectUri = "";
if (Preprod) {
    redirectUri = "https://ghdashboard-mr.preprod.connectedtech.io/"
}
else {
    redirectUri = "https://ghdashboard-mr.qa.connectedtech.io/"
}


console.log("auth ori", process.env.REACT_APP_AUTHORITY)
console.log(redirectUri);
const msalConfig = {

    auth: {
        authority: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
        clientId: '43af11ab-b6ce-4801-94d9-fd2cda50925b',
        //redirectUri: process.env.NODE_ENV === 'production' ? 'https://ghdashboard-mr.qa.connectedtech.io/' : "http://localhost:3000/"
        redirectUri: redirectUri
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
    }
};

const authenticationParameters = {
    scopes: [
        "user.read"
    ]
};

// Options
const options = {
    loginType: LoginType.Redirect,
    //tokenRefreshUri: window.location.origin +'/auth.html'
}

export const authProvider = new MsalAuthProvider(msalConfig as any, authenticationParameters, options)
